import { ReactElement } from 'react'

import { FrodaFinanceLending, FrodaFinanceLendingProviderContext } from './FrodaFinanceLending'

export const Financing = (): ReactElement => {
  return (
    <FrodaFinanceLendingProviderContext>
      <FrodaFinanceLending />
    </FrodaFinanceLendingProviderContext>
  )
}
